export class ApiError extends Error {
  private status: number;
  constructor(name: string, status: number, message?: string) {
    super(message);
    this.name = name;
    this.status = status;
    Error.apply(this, [message]);
  }
}
